import { DateTime } from 'luxon';

/**
 * Long date for the settings surfaces, in the locale the dashboard renders in.
 *
 * Shared by the subscription renewal lines and the success-fee migration card so
 * both read the same way; there is deliberately no second date helper.
 */
export const formatSettingsDate = (isoDate: string | null | undefined, locale: string): string => {
  if (!isoDate) return '-';

  const date = DateTime.fromISO(isoDate).setLocale(locale);
  if (!date.isValid) return '-';

  return date.toLocaleString({ year: 'numeric', month: 'long', day: 'numeric' });
};
